var metaVersion = document.querySelector("meta[name='version']");
var baseUrl = "/";
var urlArgs = "";

if (metaVersion) {
    urlArgs = "v=" + metaVersion.content;
}

require.config({
    baseUrl: baseUrl,
    paths: {
        NumericStringFormat: "static/legacy/0.0.4/lib/ksc-numeric-string-format/bundle",
        "komplett-pubsub": "static/legacy/0.0.4/lib/komplett-pubsub/pubsub",
        "ksc-breakpoint-notifier": "static/legacy/0.0.4/lib/ksc-breakpoint-notifier/js/main",
        "ksc-ko-extenders": "static/legacy/0.0.4/lib/ksc-ko-extenders/index",
        "ksc-alert": "static/legacy/0.0.4/lib/ksc-alert/js/main",
        "ksc-alert/ViewModel": "static/legacy/0.0.4/ib/ksc-alert/js/main",
        "ksc-ubo": "static/legacy/0.0.4/lib/ksc-ubo/js/main",
        "ksc-ubo/uboService": "static/legacy/0.0.4/lib/ksc-ubo/js/main",
        knockout: "static/legacy/0.0.4/JScript/Shims/knockout-shim",
        querystring: "static/legacy/0.0.4/JScript/Shims/querystring-shim",
        dataLayer: "static/legacy/0.0.4/JScript/Shims/datalayer-shim",
    },
    urlArgs: urlArgs,
});